import clsx from 'clsx'
import SpeedSelector from 'components/SpeedSelector'

import style from './SpeedSettingsSection.module.css'

interface SpeedSettingsSectionProps {
  cleaningSpeed: number
  transportSpeed: number
  onCleaningSpeedChange: (speed: number) => void
  onTransportSpeedChange: (speed: number) => void
  disabled?: boolean
  className?: string
  showTransportSpeed?: boolean
  showCleaningSpeed?: boolean
  noShadow?: boolean
}

const SpeedSettingsSection: React.FC<SpeedSettingsSectionProps> = ({
  cleaningSpeed,
  transportSpeed,
  onCleaningSpeedChange,
  onTransportSpeedChange,
  disabled = false,
  showTransportSpeed = true,
  showCleaningSpeed = true,
  className,
  noShadow,
}) => {
  return (
    <div className={clsx(className, style.speedSection)}>
      <SpeedSelector
        cleaningSpeed={cleaningSpeed}
        transportSpeed={transportSpeed}
        onCleaningSpeedChange={onCleaningSpeedChange}
        onTransportSpeedChange={onTransportSpeedChange}
        disabled={disabled}
        showTransportSpeed={showTransportSpeed}
        showCleaningSpeed={showCleaningSpeed}
        className={style.speedSelector}
        noShadow={noShadow}
      />
    </div>
  )
}

export default SpeedSettingsSection
